import { initializeApp } from "firebase/app";
import { getAnalytics, setUserId, logEvent } from "firebase/analytics";
import { isChromeExtension, isNativeApp } from "@/platform/runtime.js";

let analytics = null;
let analyticsLogEvent = () => {};
let analyticsSetUserId = () => {};

if (isNativeApp()) {
  document.addEventListener("deviceready", function() {
    const firebaseAnalytics = window.cordova.plugins.firebase.analytics;
    analyticsLogEvent = firebaseAnalytics.logEvent;
    analyticsSetUserId = firebaseAnalytics.setUserId;
  });
} else if (!isChromeExtension()) {
  const firebaseConfiguration = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID,
    measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
  };
  const app = initializeApp(firebaseConfiguration);
  analytics = getAnalytics(app);
  analyticsSetUserId = function(userId) {
    setUserId(analytics, userId);
  };
  analyticsLogEvent = function(eventName, eventParams) {
    logEvent(analytics, eventName, eventParams);
  };
}

export { analyticsSetUserId, analyticsLogEvent };
